export const BASE_API_URL = process.env.REACT_APP_API_URL + "/api/v1";
export const BASE_URL = process.env.REACT_APP_API_URL;
export const API_HOSTNAME_URL = process.env.REACT_APP_API_HOSTNAME;
export const TELEGRAM_RESOURCES_URL = "https://t.me/bola_himoyasi_resources";

export const TOKEN_REFRESH = "/auth/token/refresh/";
export const AUTH_TOKEN = "/auth/token/";
export const AUTH_ME = "/auth/me/";
export const AUTH_PASSWORD_CHANGE = "/auth/password/change/";
export const AUTH_UPDATE_USER = "/auth/update/user/";
export const AUTH_UPDATE_AVATAR = "/auth/update/avatar/";
export const MODERATOR_NEWS = "/moderator/news/";

export const MODERATOR_CHAT = "/moderator/chat/";
export const MODERATOR_MESSAGE = "/moderator/message/";

export const READ_ALL_MESSAGES = "/read-all-messages/";

export const MODERATOR_FAQ = "/moderator/faq/";
export const MODERATOR_BANNER = "/moderator/banner/";

export const MODERATOR_HELP = "/moderator/help/";

export const MODERATOR_PLACE = "/moderator/place/";

export const MODERATOR_USER = "/moderator/user/";
export const MODERATOR_COUNT = "/moderator/count/";

export const VICTIM_STATISTICS = "/victim/statistics/";

export const MODERATOR_NOTIFICATION = "/moderator/notification/";

export const MODERATOR_QUESTION = "/moderator/question/";
export const MODERATOR_QUESTION_CATEGORY = "/moderator/question/category/";

export const MODERATOR_COURSE_CATEGORY = "/moderator/course/category/";

export const MODERATOR_COURSE_LESSON = "/moderator/course/lesson/";

export const MODERATOR_COURSE_LESSON_RESOURCE =
  "/moderator/course/lesson/resource/";
export const MODERATOR_TEST = "/moderator/test/";
export const MODERATOR_TEST_QUESTION = "/moderator/test/question/";

export const MODERATOR_VICTIM = "/moderator/victim/";
export const MODERATOR_VICTIM_TYPE = "/moderator/victim/type/";
export const MODERATOR_VICTIM_STATUS = "/moderator/victim/status/";

export const MODERATOR_ABOUT_PROJECT = "/moderator/about/project/";
export const MODERATOR_ABOUT_TEAM = "/moderator/about/";

export const MODERATOR_QUESTIONARE_CATEGORY =
  "/moderator/questionare/category/";
export const MODERATOR_QUESTIONARE = "/moderator/questionare/";
export const MODERATOR_QUESTIONARE_ANSWER = "/moderator/questionare/answer/";
